import { useEffect, useMemo, useState } from "react";
import { CommunityMediaEnum } from "../../../community/enums/CommunityMediaEnum"
import { CommunityMediaModel } from "../../../community/models/CommunityMediaModel";
import clsx from "clsx";
import { CommunityMediaIcon } from "../../../community/components/CommunityMediaIcon";
import { GetRelativeDate } from "../../../community/utils/DateTransform";

const mediaTypes = {
    [CommunityMediaEnum.image]: "Media",
    [CommunityMediaEnum.video]: "Media",
    [CommunityMediaEnum.audio]: "Media",
    [CommunityMediaEnum.link]: "Link",
    [CommunityMediaEnum.document]: "Doc"
}

type Props = {
    mediafiles: CommunityMediaModel[];
}

export const MediaMessageList = ({ mediafiles }: Props) => {
    const [open, setOpen] = useState(true);
    const types = ["All", "Media", "Link", "Doc"];
    const [activeType, setActiveType] = useState<string>("All");
    const [list, setList] = useState<CommunityMediaModel[]>([]);
    
    const filteredList = useMemo(() => {
        return list.filter(l => activeType === "All" || (mediaTypes[l.type]) === activeType)
    }, [activeType, list]);

    useEffect(() => {
        setList(mediafiles);
    }, [mediafiles]);

    const _handleSelectType = (type: string) => {
        setActiveType(type);
    }

    return (
        <div className="community-media" style={{ boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.03)' }}>
            <div className={clsx("community-media__header", { 'closed': !open })} onClick={() => setOpen(prev => !prev)}>
                <span>Files and links</span>

                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M12.5192 9.70701C12.4756 9.75059 12.4239 9.78517 12.367 9.80876C12.3101 9.83235 12.2491 9.84449 12.1875 9.84449C12.1259 9.84449 12.0649 9.83235 12.008 9.80876C11.9511 9.78517 11.8994 9.75059 11.8559 9.70701L7.50002 5.35056L3.14416 9.70701C3.0562 9.79497 2.93691 9.84438 2.81252 9.84438C2.68813 9.84438 2.56883 9.79497 2.48088 9.70701C2.39292 9.61905 2.34351 9.49976 2.34351 9.37537C2.34351 9.25098 2.39292 9.13168 2.48088 9.04373L7.16838 4.35623C7.21191 4.31265 7.26361 4.27807 7.32051 4.25448C7.37742 4.23089 7.43842 4.21875 7.50002 4.21875C7.56162 4.21875 7.62261 4.23089 7.67952 4.25448C7.73642 4.27807 7.78812 4.31265 7.83166 4.35623L12.5192 9.04373C12.5627 9.08726 12.5973 9.13896 12.6209 9.19587C12.6445 9.25277 12.6566 9.31377 12.6566 9.37537C12.6566 9.43697 12.6445 9.49797 12.6209 9.55487C12.5973 9.61178 12.5627 9.66348 12.5192 9.70701Z" fill="#151515"/>
                </svg>
            </div>

            {open && (
                <>
                    <div className="community-media__types">
                        {types.map((t,i) => (
                            <button 
                                key={i} 
                                className={clsx({ 'active': activeType === t })}
                                onClick={() => _handleSelectType(t)}
                            >
                                {t}
                            </button>
                        ))}
                    </div>
                    
                    <div className="community-media__files">
                        {filteredList.map((l, i) => (
                            <section key={i} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', width: '100%' }}>
                                <button onClick={() => window.open(l.url, '_blank')} style={{ minWidth: '0' }}>
                                    <CommunityMediaIcon type={l.type} />
                                    <div className="title" style={{ minWidth: 0 }}>
                                        <span>{l.filename}</span>
                                        <span>{l.author}</span>
                                    </div>

                                    <div className="meta">
                                        {l.type !== "link" && <span>{l.bytes}</span>}
                                        <span>{GetRelativeDate(l.createdAt)}</span>
                                    </div>
                                </button>
                            </section>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}